/**
 * Whether a lesson run saves and resumes progress.
 *
 * Students persist (state, responses, mastery, exploration events). A teacher
 * walking a lesson always starts fresh and writes nothing: their answers must
 * not resume next time, and must not count as student evidence.
 */
export function shouldPersistLessonRun(mode, email) {
  return mode !== "teacher" && !!String(email || "").trim();
}

/**
 * Load the saved progress and mastery for a run. When `persists` is false it
 * returns a fresh run without calling either loader. Load failures are logged
 * and degrade to the fresh value; they never stop a lesson opening.
 */
export async function loadLessonRunProgress({
  persists,
  loadState,
  loadMastery,
  coverIndex,
}) {
  let sessionState = {};
  let stepIndex = coverIndex;
  let mastery = [];
  if (!persists) return { sessionState, stepIndex, mastery };

  try {
    const saved = await loadState();
    sessionState = saved?.state_json || {};
    stepIndex =
      Number.isFinite(saved?.step_index) && saved.step_index > 0
        ? saved.step_index
        : coverIndex;
  } catch (error) {
    console.warn("[LESSON] Could not load saved progress:", error?.message);
  }

  try {
    const result = await loadMastery();
    mastery = result?.concepts || [];
  } catch (error) {
    console.warn("[LESSON] Mastery unavailable:", error?.message);
  }
  return { sessionState, stepIndex, mastery };
}
